export default __webpack_public_path__ + "static/media/hoot-spinner.8d739300.gif";